import invariant from 'invariant'

export function invariantIntlContext(intl) {
  invariant(
    intl,
    '[@dooer/react-intl] Could not find required `intl` object. ' +
      '<IntlProvider> needs to exist in the component ancestry.'
  )
}
